import React from "react";

export const BodyAndMindContext = React.createContext();